module.exports = __webpack_public_path__ + "img/Kurz.ac1e343f.jpeg";